import Environment from '../shared/Environment';
import * as Sentry from '@sentry/browser';

const actions = {
  userLogin: 'USER_LOGIN',
  userLogout: 'USER_LOGOUT',
  userLoginFailure: 'USER_LOGIN_FAILRE',
  userLoginFailureClear: 'USER_LOGIN_FAILURE_CLEAR'
};

const userLoginAction = (user) => {
  return { type: actions.userLogin, user };
};

const userLoginFailureAction = (message) => {
  return { type: actions.userLoginFailure, message };
};

export const userLoginFailureClearAction = () => {
  return { type: actions.userLoginFailureClear };
};

export const userClearAction = () => {
  return async (dispatch) => {
    const options = {
      method: 'POST',
      credentials: 'include'
    };
    const request = new Request(Environment.API + 'logout', options);

    fetch(request)
      .then(() => {
        dispatch({ type: actions.userLogout });
      })
      .catch((error) => {
        console.log(error);
        dispatch({ type: actions.userLogout });
      });
  };
};

export const fetchUserAction = () => {
  return async (dispatch) => {
    const options = {
      method: 'GET',
      credentials: 'include'
    };
    const request = new Request(Environment.API + 'user.json', options);

    try {
      const response = await fetch(request);
      if (response.ok) {
        const user = await response.json();
        Sentry.configureScope((scope) => {
          scope.setUser({ "email": user.email });
        });
        dispatch(userLoginAction({
          ...user
        }));
        return user;
      } else if (response.status === 401) {
        dispatch({ type: actions.userLogout });
        return null;
      }
    } catch (error) {
      console.log(error);
      dispatch(userLoginFailureAction('Failed to fetch user info'));
      return null;
    }
  };
};

export default (state = null, action) => {
  switch (action.type) {
    case actions.userLogin:
      return action.user;
    case actions.userLoginFailure:
      return { errorMessage: action.message };
    case actions.userLogout:
      return null;
    case actions.userLoginFailureClear:
      return null;
    default:
      return state;
  }
};
